import {
  Workout,
  WorkoutPlansTableResponse,
  Workoutupdate,
  WorkoutDatabyId,
  WorkoutUpdateResponse,
  workoutUpdateStatus,
  WorkoutDay,
  ExerciseTableServerTypes,
  getWorkoutdayExerciseResponse,
  exerciseByWorkoutDayUpdateInput,
  exerciseByWorkoutDayUpdateResponse,
  workoutDayExerciseInput,
  WorkoutPlanInput,
  WorkoutPlanResponse,
} from "@/types";
import { ApiResponse } from "@/types";
import { apiSlice } from "@/redux/apiSlice";
interface workoutQuery {
  query: string;
  org_id: number;
  goals?: string[];
  category_ids?: number[];
}

interface WorkoutQueryParams {
  workoutId?: string;
  org_id: number;
  include_days?: boolean;
  include_days_and_exercises?: boolean;
}
interface verifyWorkout {
  id: number;
  org_id: number;
}
export const workoutApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    addWorkout: builder.mutation<ApiResponse, Workout>({
      query: (workoutdata) => ({
        url: "/workouts",
        method: "POST",
        body: workoutdata,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["Workout", "Consultation"],
    }),
    getAllWorkout: builder.query<WorkoutPlansTableResponse, workoutQuery>({
      query: (searchCritiria) => {
        const params = new URLSearchParams();
        params.append("org_id", String(searchCritiria.org_id));
        params.append("include_days", "false");
        params.append("include_days_and_exercises", "false");
        params.append("created_and_assigned", "false");

        // Append repeated goals params (e.g. goals=Lose%20Weight&goals=Build%20Muscle)
        if (searchCritiria.goals?.length) {
          searchCritiria.goals.forEach((g) => params.append("goals", g));
        }

        // Append repeated category_ids params (e.g. category_ids=54&category_ids=76)
        if (searchCritiria.category_ids?.length) {
          searchCritiria.category_ids.forEach((id) =>
            params.append("category_ids", String(id))
          );
        }

        const queryString = searchCritiria.query?.length > 0
          ? `&${searchCritiria.query}`
          : "";

        return {
          url: `/workouts?${params.toString()}${queryString}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        };
      },
      providesTags: ["Workout"],
    }),
    deleteWorkout: builder.mutation<
      number,
      {
        workoutid: number;
        org_id: number;
      }
    >({
      query: (workoutdata) => ({
        url: `/workouts/${workoutdata.workoutid}?org_id=${workoutdata.org_id}`,
        method: "DELETE",
        headers: {
          Accept: "application/json",
          "content-Type": "application/json",
        },
      }),
      invalidatesTags: ["Workout", "Consultation"],
    }),
    updateWorkout: builder.mutation<WorkoutUpdateResponse, Workoutupdate>({
      query: (workoutdata) => ({
        url: `/workouts/${workoutdata.id}`,
        method: "PUT",
        body: workoutdata,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["Workout", "Consultation"],
    }),
    updateWorkoutStatus: builder.mutation<WorkoutUpdateResponse, { id: number; org_id: number; status: string }>({
      query: ({ id, org_id, status }) => ({
        url: `/workouts/${id}/status?org_id=${org_id}&status=${status}`,
        method: "PATCH",
        headers: {
          Accept: "application/json",
        },
      }),
      invalidatesTags: ["Workout", "Consultation"],
    }),
    updateWorkoutgrid: builder.mutation<
      WorkoutUpdateResponse,
      workoutUpdateStatus
    >({
      query: (workoutdata) => ({
        url: `/workouts/${workoutdata.id}`,
        method: "PUT",
        body: workoutdata,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["Workout", "Consultation"],
    }),
    getWorkoutById: builder.query<WorkoutDatabyId, WorkoutQueryParams>({
      query: ({
        workoutId,
        include_days,
        include_days_and_exercises,
        org_id,
      }) => {
        const params = new URLSearchParams();

        if (include_days) params.append("include_days", "true");
        if (include_days_and_exercises)
          params.append("include_days_and_exercises", "true");

        return {
          url: `/workouts/${workoutId}?org_id=${org_id}${params.toString().length > 0 ? "&" + params.toString() : ""}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        };
      },
      providesTags: ["Workout"],
    }),
    addWorkoutDay: builder.mutation<WorkoutDay, WorkoutDay>({
      query: (workoutdata) => ({
        url: `/workouts/${workoutdata.workout_id}/days`,
        method: "POST",
        body: workoutdata,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["WorkoutDay", "Workout", "Consultation"],
    }),
    updateWorkoutDay: builder.mutation<WorkoutDay, WorkoutDay>({
      query: (workoutdata) => ({
        url: `/workouts/${workoutdata.workout_id}/days/${workoutdata.id}`,
        method: "PUT",
        body: workoutdata,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["Workout", "Consultation"],
    }),
    deleteWorkoutDay: builder.mutation<
      { status: number; message: string },
      {
        workout_id: number;
        id: number;
      }
    >({
      query: (workoutdata) => ({
        url: `/workouts/${workoutdata.workout_id}/days/${workoutdata.id}`,
        method: "DELETE",
        headers: {
          Accept: "application/json",
        },
      }),
      invalidatesTags: ["Workout", "Consultation"],
    }),
    getAllExerciseForWorkout: builder.query<
      ExerciseTableServerTypes,
      workoutQuery
    >({
      query: (SearchCriteria) => ({
        url: `/exercise?org_id=${SearchCriteria.org_id}${SearchCriteria.query?.length > 0 ? "&" + SearchCriteria.query : ""}`,
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      }),
      providesTags: ["Exercise"],
    }),
    addExerciseInWorkout: builder.mutation<
      getWorkoutdayExerciseResponse,
      workoutDayExerciseInput
    >({
      query: (workoutdata) => ({
        url: `/workouts/days/${workoutdata.workout_day_id}/exercises`,
        method: "POST",
        body: workoutdata,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["Workout", "Consultation"],
    }),
    updateExerciseInWorkout: builder.mutation<
      exerciseByWorkoutDayUpdateResponse,
      exerciseByWorkoutDayUpdateInput
    >({
      query: (workoutdata) => ({
        url: `/workouts/days/exercises/${workoutdata.id}`,
        method: "PUT",
        body: workoutdata,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["Workout", "Consultation"],
    }),
    getExerciseByWorkoutDayId: builder.query<
      getWorkoutdayExerciseResponse[],
      number
    >({
      query: (workoutdayId) => ({
        url: `/workouts/days/${workoutdayId}/exercises`,
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      }),
      providesTags: ["Workout"],
    }),
    deleteExerciseInWorkoutday: builder.mutation<
      { status: number; message: string },
      {
        workout_id: number;
        exercise_id: number;
      }
    >({
      query: (workoutdata) => ({
        url: `/workouts/${workoutdata.workout_id}/days/exercises/${workoutdata.exercise_id}`,
        method: "DELETE",
        headers: {
          Accept: "application/json",
        },
      }),
      invalidatesTags: ["Workout", "Consultation"],
    }),
    verifyWorkoutCreation: builder.mutation<
      { message: string; status: number },
      verifyWorkout
    >({
      query: (workoutdata) => ({
        url: `/workouts/${workoutdata.id}/verify?org_id=${workoutdata.org_id}`,
        method: "POST",
        // body: workoutId,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["Workout", "Consultation"],
    }),
    getMemberWorkoutPlans: builder.query<WorkoutPlansTableResponse, { member_id: number; org_id: number; sort_order?: string }>({
      query: ({ member_id, org_id, sort_order = "asc" }) => ({
        url: `/workouts/plans?org_id=${org_id}&member_id=${member_id}&sort_order=${sort_order}`,
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      }),
      providesTags: ["Workout"],
    }),
    createWorkoutPlan: builder.mutation<WorkoutPlanResponse, WorkoutPlanInput>({
      query: (data) => ({
        url: "/workouts/plans",
        method: "POST",
        body: data,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["Workout", "Consultation"],
    }),
    getWorkoutPlanByWorkoutId: builder.query<WorkoutPlanResponse[], { org_id: number; workout_id: number }>({
      query: ({ org_id, workout_id }) => ({
        url: `/workouts/plans?org_id=${org_id}&workout_id=${workout_id}&sort_order=asc`,
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      }),
      providesTags: ["Workout"],
    }),
  }),
});

export const {
  useAddWorkoutMutation,
  useGetAllWorkoutQuery,
  useDeleteWorkoutMutation,
  useUpdateWorkoutMutation,
  useGetWorkoutByIdQuery,
  useLazyGetWorkoutByIdQuery,
  useUpdateWorkoutgridMutation,
  useAddWorkoutDayMutation,
  useDeleteWorkoutDayMutation,
  useUpdateWorkoutDayMutation,
  useGetAllExerciseForWorkoutQuery,
  useAddExerciseInWorkoutMutation,
  useUpdateExerciseInWorkoutMutation,
  useGetExerciseByWorkoutDayIdQuery,
  useLazyGetExerciseByWorkoutDayIdQuery,
  useDeleteExerciseInWorkoutdayMutation,
  useVerifyWorkoutCreationMutation,
  useGetMemberWorkoutPlansQuery,
  useUpdateWorkoutStatusMutation,
  useCreateWorkoutPlanMutation,
  useGetWorkoutPlanByWorkoutIdQuery,
} = workoutApi;
